// Import Libraries
import React, { useEffect, useState, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Import Components
import StripeNewCard from './StripeNewCard';
import LoadingSpinner from '../../Elements/LoadingSpinner';

// Import Services
import paymentService from '../../../services/paymentService';

// Context
import { UserContext } from '../../../context/User';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);

const WrappedStripeNewCard = ({ hasCards, setNewCard, scriptId, invoice, nextStep, orderInfo, userId }) => {
  const { user, setUser } = useContext(UserContext);
  const targetUserId = userId ?? user?.id;
  const [clientSecret, setClientSecret] = useState('');
  // Without this the card form just never appears when the setup intent
  // fails, leaving the user with nothing to act on.
  const [setupFailed, setSetupFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const setupIntent = async () => {
      // orderInfo is absent when paying an outstanding invoice (PaymentDue).
      if (orderInfo?.selectedPlan || invoice) {
        setSetupFailed(false);
        try {
          const intent = await paymentService.createSetupIntent(targetUserId);
          if (intent?.clientSecret) {
            setClientSecret(intent.clientSecret);
            setUser({ ...user, stripeCustomerId: intent.customerId });
          } else {
            console.error('Error creating setup intent: no client secret returned', intent);
            setSetupFailed(true);
          }
        } catch (error) {
          console.error('Error creating setup intent:', error);
          setSetupFailed(true);
        }
      }
    };

    setupIntent();
  }, [orderInfo, invoice, attempt]);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  return (
    <>
      {clientSecret ? (
        <Elements options={options} stripe={stripePromise}>
          <StripeNewCard
            hasCards={hasCards ? true : false}
            setNewCard={setNewCard}
            scriptId={scriptId}
            clientSecret={clientSecret}
            invoice={invoice}
            nextStep={nextStep}
            orderInfo={orderInfo}
            userId={targetUserId}
          />
        </Elements>
      ) : setupFailed ? (
        <div className="fullWidthContainer" style={{ textAlign: 'center' }}>
          <div className="errorText" style={{ marginBottom: 12 }}>
            We couldn't load the card form. Please try again.
          </div>
          <button type="button" className="buttonClone" onClick={() => setAttempt((n) => n + 1)}>
            Try Again
          </button>
        </div>
      ) : orderInfo?.selectedPlan || invoice ? (
        <div style={{ textAlign: 'center', padding: 20 }}>
          <LoadingSpinner />
        </div>
      ) : null}
    </>
  );
};

export default WrappedStripeNewCard;
